import React, { lazy } from 'react';
const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));
import { CaptchaSectionStyle } from './Captcha.styled';
import { useTranslation } from '../../hooks/useTranslation';

const Captcha = ({
  handleCAPTCHA = () => {},
  captchaRef,
  isCaptchaVerified,
}) => {
  const t = useTranslation();
  return (
    <CaptchaSectionStyle>
      <div className='captchaStyle'>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_SITE_KEY}
          onChange={handleCAPTCHA}
          ref={captchaRef}
        />
      </div>
      {!isCaptchaVerified && (
        <span className='error-message'>
          {t('app.PLEASE_COMPLETE_THE_CAPTCHA_TO_PROCEED')}
        </span>
      )}
    </CaptchaSectionStyle>
  );
};

export default Captcha;
